<template>
	<!-- 登录 -->
	<div class="login" >
		<div class="loginPC" :style="loginPCStyle" v-loading="loading" :element-loading-text="lodingText"
			element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)"
			style="width: 100%">
			<div class="loginPC-content">
				<div class="loginPC-content-img"></div>
				<div class="loginPC-content-p" v-if="oneLogin == false">
					<div class="loginPC-content-p-text">飞砂走石云平台</div>
					<div class="loginPC-content-p-from">
						<div class="loginPC-content-p-from-name">
							<el-input placeholder="请输入账号" v-model="ueseinfo.name" maxlength="11" @input="accountBlur">
								<i slot="prefix" class="el-input__icon el-icon-user"></i>
							</el-input>
							<div class="loginPC-error-text">
								<span v-if="accountErr">请输入有效账号</span>
							</div>
						</div>
						<!-- <div class="loginPC-content-Period-from-check">
							<div class="loginPC-content-Period-from-check-l">
								<el-input :readonly='readonly' @focus='handlerIptClick' placeholder="验证码" oninput="value=value.replace(/[^\d]/g,'')" maxlength="6" v-model="ueseinfo.checkNum">
									<i slot="prefix" class="el-input__icon el-icon-circle-check"></i>
								</el-input>
							</div>
							<div class="loginPC-content-Period-from-check-r">
								<el-button type="primary" :disabled="checkDisable" @click="countdown">{{ checkText }}
								</el-button>
							</div>
						</div> -->
						<div class="loginPC-content-p-from-pas">
							<el-input placeholder="请输入密码" v-model="ueseinfo.password" type="password" maxlength="16">
								<i slot="prefix" class="el-input__icon el-icon-lock"></i>
							</el-input>
						</div>
						<div v-if="authorizecodeBoll" class="loginPC-content-p-from-pas">
							<el-input placeholder="请输入授权码" v-model="ueseinfo.authorizecode" type="password"
								maxlength="16">
								<i slot="prefix" class="el-input__icon el-icon-s-check"></i>
							</el-input>
						</div>
					</div>
					<!-- <el-button class="tabBut" type="text" @click="forgetClick">客户登录</el-button> -->
					<button class="loginPC-content-p-btn pulic_cursor"
						:class="isLogin ? '' : 'loginPC-content-p-btn-bgc'" @click="submit">
						登录
					</button>
					<div class="loginPC-content-p-bottom">
						<!-- <div class="loginPC-content-p-bottom-forget" @click="forgetClick">
              忘记密码?
            </div> -->
						<el-button style="padding: 0;font-size:1.042vw;" class="loginPC-content-p-bottom-forget"
							type="text" @click="forgetClick">忘记密码?</el-button>
						<div class="loginPC-content-p-bottom-remember" v-if="LoginMethodCode != 'YZM'">
							记住密码
							<el-switch v-model="switchvalue" @change="switchChange">
							</el-switch>
						</div>
					</div>
					<div class="download">
						<div>
							<img style="heigth: 100px; width: 100px"
								src="https://feishazoushi.cn/appImages/downCustomer.png" alt="" />
						</div>
						<div style="margin-top: 10px">
							<a>扫码下载</a>
							<a style="margin-left: 10px; margin-right: 10px">|</a>
							<a href="https://shashiwangluo.oss-cn-hangzhou.aliyuncs.com/customer.apk" style="color: #00aaff">点击下载</a>
						</div>
					</div>
				</div>
				<div class="loginPC-content-p loginPC-content-Period" v-if="oneLogin">
					<div class="loginPC-content-p-text">飞砂走石云平台</div>
					<div class="loginPC-content-Period-from">
						<div class="loginPC-content-Period-from-name">
							<el-input placeholder="请输入账号" v-model="oneUserInfo.name" maxlength="11"
								@blur="firstAccountBlur">
								<i slot="prefix" class="el-input__icon el-icon-user"></i>
							</el-input>
							<div class="loginPC-error-text">
								<span v-if="firstAccountErr">请输入有效账号</span>
							</div>
						</div>
						<div class="loginPC-content-Period-from-check">
							<div class="loginPC-content-Period-from-check-l" maxlength="6">
								<el-input placeholder="验证码" v-model="oneUserInfo.checkNum">
									<i slot="prefix" class="el-input__icon el-icon-circle-check"></i>
								</el-input>
							</div>
							<div class="loginPC-content-Period-from-check-r">
								<el-button type="primary" :disabled="checkDisable" @click="countdown">{{ checkText }}
								</el-button>
							</div>
						</div>
						<div class="loginPC-content-Period-from-pas">
							<el-form :model="oneUserInfo" status-icon :rules="rules" ref="oneUserInfo"
								label-width="100px" class="demo-ruleForm">
								<el-form-item prop="pass">
									<el-input type="password" placeholder="请设置密码" v-model="oneUserInfo.pass"
										autocomplete="off" maxlength="16">
										<i slot="prefix" class="el-input__icon el-icon-lock"></i>
									</el-input>
									<span class="loginPC-content-Period-from-pas-text">密码需包含字母、数字，长度不低于6位</span>
								</el-form-item>
								<el-form-item prop="checkPass">
									<el-input type="password" placeholder="请再次输入密码" v-model="oneUserInfo.checkPass"
										autocomplete="off" maxlength="16">
										<i slot="prefix" class="el-input__icon el-icon-lock"></i>
									</el-input>
								</el-form-item>
							</el-form>
						</div>
						<button class="loginPC-content-p-btn pulic_cursor"
							:class="oneIsLogin ? '' : 'loginPC-content-p-btn-bgc'" @click="submit">
							登录
						</button>
						<div class="loginPC-content-p-bottom">
							<!-- <div class="loginPC-content-p-bottom-forget"></div> -->
							<div class="loginPC-content-p-bottom-remember">
								记住密码
								<el-switch v-model="oneSwitchValue" @change="oneSwitchChange">
								</el-switch>
							</div>
						</div>
					</div>
				</div>
			</div>
			<el-dialog :visible.sync="forgetDigVisible" @close="forgetClose" width="35%" append-to-body custom-class="login-dialog">
				<div class="loginPC-forgetdiagl">
					<el-form :model="forgetUserInfo" status-icon :rules="forgetRules" ref="forgetUserInfo"
						label-width="150px" class="forgetDig-rules">
						<el-form-item label="请输入手机号:" prop="name">
							<el-input type="text" placeholder="请输入手机号" v-model="forgetUserInfo.name"
								@blur="forgetAccountBlur" maxlength="11"></el-input>
							<div class="loginPC-error-text" style="padding: 0 0 5px 0; font-size: 12px">
								<span v-if="forgetAccountErr">请输入有效账号</span>
							</div>
						</el-form-item>
						<el-form-item label="请输入验证码:" prop="checkNum">
							<div class="loginPC-forget-check">
								<div>
									<el-input type="text" placeholder="请输入6位数字" v-model="forgetUserInfo.checkNum"
										maxlength="6"></el-input>
								</div>
								<div>
									<el-button type="primary" :disabled="forgetCheckDisable" @click="forgetCountdown">
										{{ forgetCheckText }}
									</el-button>
								</div>
							</div>
						</el-form-item>
						<el-form-item label="请输入新密码:" prop="pass">
							<el-input type="password" placeholder="密码为6-16位数字字母组合" v-model="forgetUserInfo.pass"
								autocomplete="off" maxlength="16"></el-input>
						</el-form-item>
						<el-form-item label="请确认新密码:" prop="checkPass">
							<el-input type="password" placeholder="请再次输入新密码" v-model="forgetUserInfo.checkPass"
								autocomplete="off" maxlength="16"></el-input>
						</el-form-item>
					</el-form>
					<div class="loginPC-forget-bottom">
						<button type="default" @click="upPassword">确认</button>
						<button type="default" @click="reset">重置</button>
					</div>
				</div>
			</el-dialog>
			
			
		</div>
		<div class="loginPC-copyright">
			<span>
				<a class="text-hover" href="https://beian.miit.gov.cn/" target="_blank" style="padding-right:30px;"><span style="padding-right:30px;">豫ICP备2021023431号</span><span>该版权技术由河南沙石网络科技有限公司支持</span></a>
			</span>
		</div>
		
	</div>

</template>
<script>
	export default {
		data() {
			var valPas = (rule, value, callback) => {
				//第一次登录两次密码校验
				var reg = new RegExp(
					/^(?=.*?[a-z)(?=.*>[A-Z])(?=.*?[0-9])[a-zA-Z0-9]{6,16}$/
				);
				var isval = reg.test(value);
				if (value === "") {
					callback(new Error("请输入有效密码"));
				} else {
					if (!isval) {
						callback(new Error("请输入有效密码"));
					} else {
						if (this.oneUserInfo.checkPass !== "") {
							this.$refs.oneUserInfo.validateField("checkPass");
						}
						callback();
					}
				}
			};
			var checktValPas = (rule, value, callback) => {
				//第一次登录两次密码校验
				if (value === "") {
					callback(new Error("请再次输入密码"));
				} else if (value !== this.oneUserInfo.pass) {
					callback(new Error("两次输入密码不一致!"));
				} else {
					callback();
				}
			};
			var forgetValPas = (rule, value, callback) => {
				//修改两次密码校验
				var reg = new RegExp(
					/^(?=.*?[a-z)(?=.*>[A-Z])(?=.*?[0-9])[a-zA-Z0-9]{6,16}$/
				);
				var isval = reg.test(value);
				if (value === "" && isval == false) {
					callback(new Error("请输入有效密码"));
				} else {
					if (!isval) {
						callback(new Error("请输入有效密码"));
					} else {
						if (this.forgetUserInfo.checkPass !== "") {
							this.$refs.forgetUserInfo.validateField("checkPass");
						}
						callback();
					}
				}
			};
			var forgetChecktValPas = (rule, value, callback) => {
				//修改两次密码校验
				if (value === "") {
					callback(new Error("请再次输入密码"));
				} else if (value !== this.forgetUserInfo.pass) {
					callback(new Error("两次输入密码不一致!"));
				} else {
					callback();
				}
			};
			return {
				loginPCStyle: "",
				input4: "",
				switchvalue: false,
				readonly: true,
				ueseinfo: {
					name: "",
					password: "",
					checkNum: '',
				},
				oneUserInfo: {
					name: "",
					checkNum: "",
					pass: "",
					checkPass: "",
					authorizecode: "",
				},
				oneLogin: false, //是否为第一次登录
				authorizecodeBoll: false, //是否需要授权码
				oneSwitchValue: false,
				rules: {
					pass: [{
						validator: valPas,
						trigger: "blur"
					}],
					checkPass: [{
						validator: checktValPas,
						trigger: "blur"
					}],
				},
				checkDisable: false,
				checkText: "获取验证码",
				countdownNum: 60,
				forgetDigVisible: false,
				forgetUserInfo: {
					name: "",
					checkNum: "",
					pass: "",
					checkPass: "",
				},
				forgetRules: {
					pass: [{
						validator: forgetValPas,
						trigger: "blur"
					}],
					checkPass: [{
						validator: forgetChecktValPas,
						trigger: "blur"
					}],
				},
				forgetCheckDisable: false,
				forgetCheckText: "获取验证码",
				forgetCountdownNum: 60,
				loading: false,
				lodingText: "登录中...",
				accountErr: false,
				firstAccountErr: false,
				forgetAccountErr: false,
				isPhone: true,
				LoginMethodCode: "", //登录方式
				// 验证码登录
				MethodVerificationCode: "", //验证码
				checkDisableMethod: false,
				MethodDownNum: 60,
				MethodVerificationText: "获取验证码",
				keydownHandler: null,
				countdownTimer: null,
				forgetCountdownTimer: null,
				methodCountdownTimer: null,
			};
		},
		computed: {
			isLogin() {
				//登录按钮
				if (
					this.ueseinfo.name.trim().length > 0 &&
					this.ueseinfo.password.trim().length > 0

				) {
					return true;
				} else {
					return false;
				}
			},
			isLoginMethod() {
				//验证码登录按钮
				if (
					this.ueseinfo.name.trim().length > 0 &&
					this.MethodVerificationCode.trim().length > 0
				) {
					return true;
				} else {
					return false;
				}
			},
			oneIsLogin() {
				//第一次登录按钮
				if (
					this.oneUserInfo.name.trim().length > 0 &&
					this.oneUserInfo.pass.trim().length > 0 &&
					this.oneUserInfo.checkPass.trim().length > 0 &&
					this.oneUserInfo.checkNum.trim().length > 0
				) {
					return true;
				} else {
					return false;
				}
			},
		},
		created() {
			this.keydownHandler = e => {
				let key = e.keyCode || e.which;
				if (key == 13 || key == 108) {
					if (this.$route.path == "/Login") {
						this.submit();
					}
				}
				if (key == 32) {
					e.preventDefault();
				}
			};
			document.addEventListener('keydown', this.keydownHandler);
		},
		beforeDestroy() {
			if (this.keydownHandler) {
				document.removeEventListener('keydown', this.keydownHandler);
				this.keydownHandler = null;
			}
			this.clearCodeTimer('method');
			this.clearCodeTimer('first');
			this.clearCodeTimer('forget');
		},
		mounted() {
			sessionStorage.clear();
			this.$store.commit("setUser", "");
			this.$store.commit("setNavHistoy", "");
			this.$store.commit("setSole", "");
			this.$store.commit("upEditableTabs", []);
			this.$store.commit("setHistTabsValue", "");
			var windowH = window.innerHeight - 30;
			this.loginPCStyle = `height:${windowH}px`;
			this.getCookie();
			// console.log(this.$VERSION)
		},
		methods: {
			//去除浏览器账号与密码自动填充
			handlerIptClick() {
				this.readonly = false;
			},
			startCodeTimer(type) {
				var configMap = {
					method: {
						timerKey: 'methodCountdownTimer',
						numKey: 'MethodDownNum',
						textKey: 'MethodVerificationText',
						disableKey: 'checkDisableMethod'
					},
					first: {
						timerKey: 'countdownTimer',
						numKey: 'countdownNum',
						textKey: 'checkText',
						disableKey: 'checkDisable'
					},
					forget: {
						timerKey: 'forgetCountdownTimer',
						numKey: 'forgetCountdownNum',
						textKey: 'forgetCheckText',
						disableKey: 'forgetCheckDisable'
					}
				};
				var config = configMap[type];
				if (!config) return;
				this.clearCodeTimer(type);
				this[config.disableKey] = true;
				this[config.numKey] = 59;
				this[config.textKey] = `${this[config.numKey]}后重新获取`;
				this[config.timerKey] = setInterval(() => {
					if (this[config.numKey] == 0) {
						this.clearCodeTimer(type);
						return;
					}
					this[config.numKey]--;
					var num = this[config.numKey] < 10 ? "0" + this[config.numKey] : this[config.numKey];
					this[config.textKey] = `${num}后重新获取`;
				}, 1000);
			},
			clearCodeTimer(type) {
				var configMap = {
					method: {
						timerKey: 'methodCountdownTimer',
						numKey: 'MethodDownNum',
						textKey: 'MethodVerificationText',
						disableKey: 'checkDisableMethod'
					},
					first: {
						timerKey: 'countdownTimer',
						numKey: 'countdownNum',
						textKey: 'checkText',
						disableKey: 'checkDisable'
					},
					forget: {
						timerKey: 'forgetCountdownTimer',
						numKey: 'forgetCountdownNum',
						textKey: 'forgetCheckText',
						disableKey: 'forgetCheckDisable'
					}
				};
				var config = configMap[type];
				if (!config) return;
				if (this[config.timerKey]) {
					clearInterval(this[config.timerKey]);
					this[config.timerKey] = null;
				}
				this[config.numKey] = 60;
				this[config.textKey] = "获取验证码";
				this[config.disableKey] = false;
			},
			MethodDown() {
				//验证码登录--倒计时
				if (/^[1][3-9][0-9]{9}$/.test(this.ueseinfo.name)) {
					this.startCodeTimer('method');
					var url = "/system/getCode";
					var data = {
						PERTB006CA01: this.ueseinfo.name,
					};
					this.axios.post(url, data).then((res) => {
						// console.log(res)
						if (res.data.code != 200) {
							this.$message.error("获取验证码失败，请重试！");
						}
					});
				} else {
					this.$message.error("请输入有效手机号");
				}
			},
			countdown() {
				//倒计时
				// console.log(this.ueseinfo.name)
				if (/^[1][3-9][0-9]{9}$/.test(this.oneUserInfo.name)) {
					this.startCodeTimer('first');
					var url = "/system/getCode";
					var data = {
						PERTB006CA01: this.oneUserInfo.name,
					};
					this.axios.post(url, data).then((res) => {
						// console.log(res)
						if (res.data.code != 200) {
							this.$message.error("获取验证码失败，请重试！");
						}
					});
				} else {
					this.$message.error("请输入有效手机号");
				}
			},
			forgetCountdown() {
				//忘记密码倒计时
				if (/^[1][3-9][0-9]{9}$/.test(this.forgetUserInfo.name)) {
					this.startCodeTimer('forget');
					var url = "/system/getCode";
					var data = {
						PERTB006CA01: this.forgetUserInfo.name,
					};
					this.axios.post(url, data).then((res) => {
						// console.log(res)
						if (res.data.code != 200) {
							this.$message.error("获取验证码失败，请重试！");
						}
					});
				} else {
					this.$message.error("请输入有效手机号");
				}
			},
			accountBlur() {
				//校验账号
				var index = this.ueseinfo.name.indexOf(`xst${new Date().getFullYear()}`);
				if (index != -1) return;
				if (!/^[1][3-9][0-9]{9}$/.test(this.ueseinfo.name)) {
					this.accountErr = true;
					var that = this;
					setTimeout(function() {
						that.accountErr = false;
					}, 3000);
				} else {
					// this.loading=true
					this.isFirstLogin();
				}
			},
			firstAccountBlur() {
				//第一次登录校验账号
				if (!/^[1][3-9][0-9]{9}$/.test(this.oneUserInfo.name)) {
					this.firstAccountErr = true;
					var that = this;
					setTimeout(function() {
						that.firstAccountErr = false;
					}, 3000);
				}
				if (this.oneUserInfo.name.length == 0) {
					this.oneLogin = false;
					this.isPhone = false;
					this.ueseinfo = {
						name: "",
						password: "",
					};
				}
			},
			forgetAccountBlur() {
				//修改登录校验账号
				if (!/^[1][3-9][0-9]{9}$/.test(this.forgetUserInfo.name)) {
					this.forgetAccountErr = true;
					var that = this;
					setTimeout(function() {
						that.forgetAccountErr = false;
					}, 3000);
				}
			},
			forgetClick() {
				//忘记密码
				this.forgetDigVisible = !this.forgetDigVisible;
			},
			forgetClose() {
				//忘记密码初始化校验
				this.$refs.forgetUserInfo.resetFields();
				this.ueseinfo = {
					name: "",
					password: "",
				};
				this.isLogin == false;
			},
			switchChange(e) {
				//设置cookie
				let self = this;
				if (e == true) {
					//传入账号名，密码，和保存天数3个参数
					self.setCookie(self.ueseinfo.name, self.ueseinfo.password, 9999999);
				} else {
					//清空Cookie
					self.clearCookie();
				}
			},
			oneSwitchChange(e) {
				//设置cookie
				let self = this;
				if (e == true) {
					//传入账号名，密码，和保存天数3个参数
					self.setCookie(
						self.oneUserInfo.name,
						self.oneUserInfo.checkPass,
						9999999
					);
				} else {
					//清空Cookie
					self.clearCookie();
				}
			},
			setCookie(c_name, c_pwd, exdays) {
				//保存cookie
				var exdate = new Date(); //获取时间
				exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * exdays); //保存的天数
				//字符串拼接cookie
				window.document.cookie =
					"userName" + "=" + c_name + ";path=/;expires=" + exdate.toGMTString();
				window.document.cookie =
					"userPwd" + "=" + c_pwd + ";path=/;expires=" + exdate.toGMTString();
			},
			getCookie() {
				//读取cookie
				if (document.cookie.length > 0) {
					this.switchvalue = true;
					this.isPhone = true;
					var arr = document.cookie.split("; "); //这里显示的格式需要切割一下自己可输出看下
					for (var i = 0; i < arr.length; i++) {
						var arr2 = arr[i].split("="); //再次切割
						//判断查找相对应的值
						if (arr2[0] == "userName") {
							this.ueseinfo.name = arr2[1]; //保存到保存数据的地方
						} else if (arr2[0] == "userPwd") {
							this.ueseinfo.password = arr2[1];
						}
					}
				}
			},
			clearCookie() {
				//清除cookie
				this.setCookie("userName", "", -1); //修改2值都为空，天数为负1天就好了
				this.setCookie("userPwd", "", -1); //修改2值都为空，天数为负1天就好了
			},
			reset() {
				//忘记密码重置
				this.$refs.forgetUserInfo.resetFields();
				this.forgetUserInfo = {
					name: "",
					checkNum: "",
					pass: "",
					checkPass: "",
				};
			},
			error(str) {
				//错误提示
				this.$message.error(str);
			},
			submit() {
				//正常登陆
				if (this.oneLogin) {
					if (!this.oneIsLogin) return this.$message.error("请完善登录信息");
					if (this.oneUserInfo.name.trim().length != 0) {
						if (/^\d{6}$/.test(this.oneUserInfo.checkNum)) {
							this.$refs.oneUserInfo.validate((valid) => {
								if (valid) {
									this.loginQuery();
								} else {
									var reg = new RegExp(
										/^(?=.*?[a-z)(?=.*>[A-Z])(?=.*?[0-9])[a-zA-Z0-9]{6,16}$/
									);
									if (!reg.test(this.oneUserInfo.pass))
										return this.$message.error("请输入有效密码");
									if (!reg.test(this.oneUserInfo.checkPass))
										return this.$message.error("请输入有效密码");
									this.$message.error("两次密码不一致，请重新输入");
								}
							});
						} else {
							this.$message.error("请输入六位有效验证码");
						}
					} else {
						this.$message.error("请输入有效手机号");
					}
				} else {
					if (this.isLogin == false) return this.$message.error("请完善登录信息");
					var index = this.ueseinfo.name.indexOf(
						`xst${new Date().getFullYear()}`
					);
					if (index == -1) {
						if (!/^[1][3-9][0-9]{9}$/.test(this.ueseinfo.name))
							return this.$message.error("请输入有效手机号");
						if (!this.isPhone) return this.$message.error("该用户不存在！");
					}
					if (this.ueseinfo.password.trim().length < 6)
						return this.$message.error("请输入有效密码");
					this.loginQuery();
				}
			},
			loginQuery() {
				// this.isFirstLogin()
				var url = "/user/login";
				this.loading = true;
				if (this.oneLogin) {
					var data = {
						PERTB005CA03: this.oneUserInfo.name,
						PERTB005CA01: this.oneUserInfo.checkPass,
						flag: true,
						PERTB006CA00: this.oneUserInfo.checkNum,
					};
				} else {
					var data = {
						PERTB005CA03: this.ueseinfo.name,
						PERTB005CA01: this.ueseinfo.password,
						authorizecode: this.ueseinfo.authorizecode,
						flag: false,
					};
				}

				this.axios
					.post(url, data)
					.then((res) => {
												
						// console.log(res, '登录成功');
						setTimeout(() => {
							this.loading = false;
						}, 500);
						if (res.data.code == 200) {
							this.$store.commit("setUser", res.data.data);
							// console.log(res.data.data)
							sessionStorage.setItem("token", res.data.data.token);
							if (this.switchvalue) {
								this.setCookie(
									this.ueseinfo.name,
									this.ueseinfo.password,
									9999999
								);
							}
							this.$router.push("/Home");
							this.$message.success(res.data.message)

						}
						if (res.data.code === 500) {
							this.authorizecodeBoll = true
							this.$message.error(res.data.message);

						} else {

							// this.$message.success(res.data.message);
						}
					})
					.catch(() => {
						this.loading = false;
					});
			},
			isFirstLogin() {
				//校验是否为第一次登录
				var url = `/system/checkPhone/${this.ueseinfo.name}`;
				this.axios
					.get(url)
					.then((res) => {
						// console.log(res)
						// this.loading=false
						if (res.data.code == 202) {
							this.oneLogin = true;
							this.oneUserInfo.name = this.ueseinfo.name;
							this.$message.error(res.data.message);
						} else if (res.data.data == 1) {
							this.authorizecodeBoll = true
							this.$message.error('请输入授权码');
						} else if (res.data.data == 0) {
							this.authorizecodeBoll = false
							// this.$message.error('请输入授权码');
						} else if (res.data.code == 203) {
							this.isPhone = true;
						} else if (res.data.code == 201) {
							this.isPhone = false;
						} else {
							this.$message.error(res.data.message);
						}
					})
					.catch(() => {
						this.loading = false;
					});
			},
			upPassword() {
				//忘记密码
				if (/^[1][3-9][0-9]{9}$/.test(this.forgetUserInfo.name)) {
					if (/^\d{6}$/.test(this.forgetUserInfo.checkNum)) {
						this.$refs.forgetUserInfo.validate((valid) => {
							if (valid) {
								let loading = this.$loading({
									lock: true,
									text: "请求中...",
									spinner: "el-icon-loading",
									background: "rgba(0, 0, 0, 0.5)",
								});
								var url = "/system/updatepassword";
								var data = {
									username: this.forgetUserInfo.name,
									password: this.forgetUserInfo.checkPass,
									PERTB006CA00: this.forgetUserInfo.checkNum,
								};
								this.axios
									.post(url, data)
									.then((res) => {
										// console.log(res)
										setTimeout(() => {
											loading.close();
										}, 300);
										if (res.data.code == 200) {
											this.ueseinfo = {
												name: "",
												password: "",
											};
											this.isLogin == false;
											this.forgetDigVisible = !this.forgetDigVisible;
											this.$message.success("修改成功，请重新登陆。");
										} else {
											this.$message.error(res.data.message);
										}
									})
									.catch(() => {
										loading.close();
									});
							} else {
								var reg = new RegExp(
									/^(?=.*?[a-z)(?=.*>[A-Z])(?=.*?[0-9])[a-zA-Z0-9]{6,16}$/
								);
								if (!reg.test(this.forgetUserInfo.pass))
									return this.$message.error("请输入有效密码");
								if (!reg.test(this.forgetUserInfo.checkPass))
									return this.$message.error("请输入有效密码");
								this.$message.error("两次密码不一致，请重新输入");
							}
						});
					} else {
						this.$message.error("请输入有效验证码");
					}
				} else {
					this.$message.error("请输入有效账号");
				}
			},
		},
	};
</script>
<style scoped>
	.download {
		display: flex;
		flex-direction: column;
		text-align: center;
		justify-content: center;
		margin-top: 40px;
	}

	a {
		text-decoration: none;
		margin-top: 10px;
	}

	.loginPC {
		padding: 115px 125px;
		background: url(../../assets/images/login/loginBGI.jpg) no-repeat;
		background-size: 100% 100%;
		box-sizing: border-box;
	}

	.loginPC-error-text {
		height: 10px;
		padding-top: 5px;
		font-size: 16px;
		color: #f56c6c;
	}

	.loginPC-content {
		position: relative;
		top: -20px;
		display: flex;
		width: 100%;
		/* height: 100%; */
		overflow: hidden;
		box-sizing: border-box;
	}

	.loginPC-content-img {
		flex: 2.5;
		height: 100%;
		/* background: url(../../assets/images/login/loginbanner.jpg) no-repeat; */
		background-size: 100% 100%;
	}

	.loginPC-content-p {
		flex: 1;
		height: 100%;
		padding: 80px 60px 100px 60px;
		background-color: #fff;
		box-sizing: border-box;
	}

	.loginPC-content-p-text {
		text-align: center;
		font-size: 50px;
		color: #00aaff;
		margin-bottom: 70px;
	}

	.loginPC-content-p-from {
		/* width: 480px; */
		margin: auto;
	}

	.loginPC-content-p-from-name {
		padding-bottom: 41px;
		box-sizing: border-box;
	}

	.loginPC-content-p-from-pas,
	.loginPC-content-p-from-padding {
		padding-bottom: 30px;
		box-sizing: border-box;
	}

	.loginPC-content-p-from-padding {
		margin-bottom: 0 !important;
	}

	.loginPC-content-p-btn {
		display: block;
		width: 480px;
		height: 56px;
		line-height: 56px;
		margin: auto;
		font-size: 29px;
		text-align: center;
		color: #fff;
		background: rgba(0, 170, 255, 1);
		border-radius: 10px;
		border: none;
	}

	.loginPC-content-p-btn-bgc {
		background: rgba(0, 170, 255, 0.6);
	}

	.loginPC-content-p-btn:active {
		background-color: rgba(0, 170, 255, 0.3);
		border: none;
		outline: none;
	}

	.loginPC-content-p-bottom {
		width: 480px;
		margin: auto;
		display: flex;
		justify-content: space-between;
		margin-top: 19px;
		font-size: 20px;
		color: #666;
	}

	.loginPC-content-p-bottom-forget {
		/* color: #00aaff; */
	}

	.loginPC-content-Period {
		padding: 60px 60px 80px 60px;
		box-sizing: border-box;
	}

	.loginPC-content-Period-from {
		/* width: 480px; */
		margin: auto;
	}

	.loginPC-content-Period-from-check {
		display: flex;
		justify-content: space-between;
		margin-bottom: 20px;
	}

	.loginPC-content-Period-from-check-l {
		flex: 1;
	}

	.loginPC-content-Period-from-check-r {
		flex: 0.3;
		padding-left: 20px;
		text-align: right;
	}

	.loginPC-content-Period-from-pas-text {
		display: block;
		padding-top: 5px;
		font-size: 16px;
		color: #999999;
		line-height: 15px;
	}

	.loginPC-content-Period-from-name {
		margin-bottom: 14px;
	}

	.loginPC-content-Period-from-pas {
		margin-bottom: 51px;
	}

	.forgetDig-rules {
		text-align: left;
	}

	.loginPC-forget-check {
		display: flex;
		justify-content: space-between;
	}

	.loginPC-forget-check>div:last-child {
		padding-left: 20px;
	}

	.loginPC-forget-bottom {
		padding: 40px 60px 20px;
		text-align: center;
	}

	.loginPC-forget-bottom button {
		width: 96px;
		height: 36px;
		cursor: pointer;
		color: #fff;
		font-size: 16px;
		background-color: #1aa0ff;
	}

	.loginPC-forget-bottom button:last-child {
		background-color: #feb419;
		margin-left: 40px;
	}

	.loginPC-forget-btn {
		height: 56px;
		line-height: 56px;
		background-color: rgba(0, 170, 255, 1);
		text-align: center;
		color: #fff;
		font-size: 29px;
		border-radius: 28px;
	}

	.loginPC-forget-btn:active {
		background-color: rgba(0, 170, 255, 0.3);
	}

	.loginPC-copyright {
		position: fixed;
		bottom: 0;
		width: 100%;
		/* line-height: 30px; */
		padding-bottom: 10px;
		text-align: center;
		font-size: 13px;
		color: #999;
	}


	.tabBut {
		padding: 0;
		padding-bottom: 20px;
		font-size: 1.042vw;
	}
	
	.text-hover {
	  color: #999; /* 默认颜色 */
	  transition: color 0.3s; /* 可选的颜色过渡效果 */
	}
	 
	.text-hover:hover {
	  color: #000; /* 鼠标移入后的颜色 */
	  /* background-color: yellow; */
	}

	/* 登录页视觉优化 */
	.loginPC {
		position: relative;
		padding: 84px 96px;
		background-image: linear-gradient(135deg, rgba(8, 40, 82, 0.18), rgba(23, 139, 255, 0.08)), url(../../assets/images/login/loginBGI.jpg);
		background-position: center;
		overflow: hidden;
	}

	.loginPC::before {
		content: "";
		position: absolute;
		left: 5%;
		top: 10%;
		width: 360px;
		height: 360px;
		border-radius: 50%;
		background: rgba(255, 255, 255, 0.18);
		filter: blur(4px);
	}

	.loginPC-content {
		top: 0;
		z-index: 1;
		min-height: calc(100vh - 168px);
		border-radius: 22px;
		background: rgba(255, 255, 255, 0.16);
		box-shadow: 0 28px 70px rgba(10, 42, 83, 0.18);
		backdrop-filter: blur(4px);
	}

	.loginPC-content-img {
		position: relative;
		background: linear-gradient(135deg, rgba(23, 139, 255, 0.16), rgba(255, 255, 255, 0.04));
	}

	.loginPC-content-img::after {
		content: "飞砂走石云平台";
		position: absolute;
		left: 54px;
		bottom: 58px;
		font-size: 34px;
		font-weight: 700;
		letter-spacing: 2px;
		color: #ffffff;
		text-shadow: 0 8px 22px rgba(0, 44, 94, 0.28);
	}

	.loginPC-content-p {
		width: 100%;
		max-width: 520px;
		min-width: 0;
		padding: 58px 58px 54px;
		background: rgba(255, 255, 255, 0.96);
		box-shadow: -18px 0 40px rgba(18, 52, 77, 0.08);
	}

	.loginPC-content-p-text {
		position: relative;
		font-size: 34px;
		font-weight: 700;
		letter-spacing: 2px;
		color: #123b66;
		margin-bottom: 48px;
	}

	.loginPC-content-p-text::after {
		content: "";
		position: absolute;
		left: 50%;
		bottom: -16px;
		width: 46px;
		height: 4px;
		margin-left: -23px;
		border-radius: 999px;
		background: linear-gradient(90deg, #178bff, #20c997);
	}

	.loginPC-content-p-from-name,
	.loginPC-content-p-from-pas,
	.loginPC-content-p-from-padding {
		padding-bottom: 24px;
	}

	.loginPC-error-text {
		font-size: 13px;
		line-height: 18px;
	}

	.loginPC-content-p-btn {
		width: 100%;
		max-width: 480px;
		height: 50px;
		line-height: 50px;
		font-size: 22px;
		font-weight: 600;
		letter-spacing: 6px;
		background: linear-gradient(135deg, #178bff 0%, #0f72d8 100%);
		border-radius: 999px;
		box-shadow: 0 12px 24px rgba(23, 139, 255, 0.26);
		transition: transform .18s ease, box-shadow .18s ease, background .18s ease;
	}

	.loginPC-content-p-btn:hover {
		transform: translateY(-1px);
		box-shadow: 0 16px 32px rgba(23, 139, 255, 0.32);
	}

	.loginPC-content-p-btn:active {
		transform: translateY(0);
		background: #0f72d8;
	}

	.loginPC-content-p-btn-bgc {
		background: linear-gradient(135deg, rgba(23, 139, 255, 0.62), rgba(15, 114, 216, 0.62));
		box-shadow: none;
	}

	.loginPC-content-p-bottom {
		width: 100%;
		max-width: 480px;
		align-items: center;
		font-size: 15px;
		color: #5f6f84;
	}

	.loginPC-content-p-bottom-forget {
		color: #178bff !important;
	}

	.download {
		max-width: 480px;
		margin: 34px auto 0;
		padding: 16px;
		border: 1px solid #e3edf7;
		border-radius: 14px;
		background: #f8fbff;
		color: #5f6f84;
	}

	.download img {
		width: 92px !important;
		height: 92px !important;
		border-radius: 10px;
		box-shadow: 0 8px 18px rgba(18, 52, 77, 0.12);
	}

	.loginPC-content-Period {
		padding: 50px 58px 46px;
	}

	.loginPC-content-Period-from-check-r .el-button {
		width: 100%;
		border-radius: 8px;
	}

	.loginPC-forget-bottom button {
		border: none;
		border-radius: 6px;
		box-shadow: 0 6px 14px rgba(26, 160, 255, 0.20);
	}

	.loginPC-forget-bottom button:last-child {
		box-shadow: 0 6px 14px rgba(254, 180, 25, 0.20);
	}

	.loginPC-copyright {
		padding-bottom: 14px;
		color: rgba(95, 111, 132, 0.92);
	}

	.text-hover {
		color: rgba(95, 111, 132, 0.92);
	}

	.text-hover:hover {
		color: #178bff;
	}

	@media screen and (max-width: 1440px) {
		.loginPC {
			padding: 60px 72px;
		}

		.loginPC-content {
			min-height: calc(100vh - 120px);
		}

		.loginPC-content-p {
			min-width: 460px;
			padding: 44px 46px;
		}

		.loginPC-content-p-text {
			font-size: 30px;
			margin-bottom: 40px;
		}
	}

	@media screen and (max-width: 1180px) {
		.loginPC {
			padding: 38px 28px;
		}

		.loginPC-content-img {
			display: none;
		}

		.loginPC-content {
			justify-content: center;
			min-height: calc(100vh - 76px);
			background: transparent;
			box-shadow: none;
		}

		.loginPC-content-p {
			flex: none;
			width: 92%;
			max-width: 520px;
			min-width: 0;
			border-radius: 20px;
			box-shadow: 0 22px 52px rgba(10, 42, 83, 0.18);
		}
	}
		@media screen and (max-width: 768px) {
			.loginPC {
				min-height: 100vh;
				padding: 24px 16px 58px;
				box-sizing: border-box;
				overflow-y: auto;
			}

			.loginPC::before {
				left: -120px;
				top: -80px;
				width: 260px;
				height: 260px;
			}

			.loginPC-content {
				min-height: auto;
			}

			.loginPC-content-p {
				width: 100%;
				padding: 32px 22px 28px;
			}

			.loginPC-content-p-text {
				font-size: 26px;
				margin-bottom: 34px;
			}

			.loginPC-content-p-from-name,
			.loginPC-content-p-from-pas,
			.loginPC-content-p-from-padding {
				padding-bottom: 18px;
			}

			.loginPC-content-p-btn {
				height: 46px;
				line-height: 46px;
				font-size: 18px;
				letter-spacing: 4px;
			}

			.loginPC-content-p-bottom {
				font-size: 13px;
			}

			.download {
				margin-top: 24px;
				padding: 12px;
			}

			.loginPC-content-Period {
				padding: 32px 22px 28px;
			}

			.loginPC-content-Period-from-check,
			.loginPC-forget-check {
				display: block;
			}

			.loginPC-content-Period-from-check-r,
			.loginPC-forget-check>div:last-child {
				padding-left: 0;
				margin-top: 12px;
			}

			.loginPC-forget-bottom {
				padding: 24px 20px 18px;
			}

			.loginPC-copyright {
				font-size: 12px;
				line-height: 18px;
				padding: 0 10px 10px;
			}
		}

		@media screen and (max-width: 480px) {
			.loginPC {
				padding: 18px 10px 54px;
			}

			.loginPC-content-p {
				padding: 28px 16px 24px;
				border-radius: 16px;
			}

			.loginPC-content-p-bottom {
				display: block;
				line-height: 26px;
			}

			.download {
				display: block;
				text-align: center;
			}

			.loginPC-forget-bottom button:last-child {
				margin-left: 14px;
			}
		}

	/* 登录页最终收敛层 */
	.loginPC {
		position: relative;
		min-height: 100vh;
		padding: 68px 88px 58px;
		background:
			radial-gradient(circle at 12% 12%, rgba(255, 255, 255, 0.40) 0, rgba(255, 255, 255, 0) 24%),
			radial-gradient(circle at 78% 18%, rgba(23, 139, 255, 0.22) 0, rgba(23, 139, 255, 0) 28%),
			linear-gradient(135deg, rgba(7, 46, 91, 0.22), rgba(23, 139, 255, 0.08)),
			url(../../assets/images/login/loginBGI.jpg) center/cover no-repeat;
		overflow: hidden;
	}

	.loginPC::before,
	.loginPC::after {
		content: "";
		position: absolute;
		border-radius: 50%;
		pointer-events: none;
	}

	.loginPC::before {
		left: 6%;
		top: 10%;
		width: 320px;
		height: 320px;
		background: rgba(255, 255, 255, 0.18);
		filter: blur(3px);
	}

	.loginPC::after {
		right: 9%;
		bottom: 12%;
		width: 220px;
		height: 220px;
		background: rgba(23, 139, 255, 0.16);
		filter: blur(8px);
	}

	.loginPC-content {
		position: relative;
		top: 0;
		z-index: 1;
		display: grid;
		grid-template-columns: minmax(360px, 1fr) minmax(420px, 520px);
		width: min(1180px, 100%);
		min-height: calc(100vh - 126px);
		margin: 0 auto;
		border: 1px solid rgba(255, 255, 255, 0.42);
		border-radius: 26px;
		background: rgba(255, 255, 255, 0.18);
		box-shadow: 0 32px 78px rgba(10, 42, 83, 0.22);
		backdrop-filter: blur(6px);
		overflow: hidden;
	}

	.loginPC-content-img {
		position: relative;
		min-height: 560px;
		background: linear-gradient(135deg, rgba(15, 114, 216, 0.24) 0%, rgba(255, 255, 255, 0.08) 100%);
	}

	.loginPC-content-img::before {
		content: "企业级运输业务协同平台";
		position: absolute;
		left: 56px;
		bottom: 112px;
		padding: 8px 14px;
		border: 1px solid rgba(255, 255, 255, 0.36);
		border-radius: 999px;
		color: rgba(255, 255, 255, 0.92);
		font-size: 15px;
		letter-spacing: 1px;
		background: rgba(255, 255, 255, 0.12);
	}

	.loginPC-content-img::after {
		content: "飞砂走石云平台";
		position: absolute;
		left: 56px;
		bottom: 58px;
		font-size: 36px;
		line-height: 1.2;
		letter-spacing: 2px;
		color: #ffffff;
		text-shadow: 0 10px 24px rgba(0, 44, 94, 0.32);
	}

	.loginPC-content-p {
		width: 100%;
		max-width: none;
		min-width: 0;
		height: auto;
		padding: 54px 56px 46px;
		background: rgba(255, 255, 255, 0.98);
		box-shadow: -18px 0 42px rgba(18, 52, 77, 0.10);
	}

	.loginPC-content-p-text {
		margin-bottom: 42px;
		color: #102f4f;
		font-size: 32px;
		font-weight: 700;
		letter-spacing: 2px;
	}

	.loginPC-content-p-from,
	.loginPC-content-Period-from {
		width: 100%;
		max-width: 480px;
	}

	.loginPC-content-p-from-name,
	.loginPC-content-p-from-pas,
	.loginPC-content-p-from-padding,
	.loginPC-content-Period-from-name,
	.loginPC-content-Period-from-pas {
		padding-bottom: 20px;
		margin-bottom: 0;
	}

	.loginPC .el-input__inner {
		height: 48px;
		line-height: 48px;
		padding-left: 42px;
		border-color: #dce8f5;
		border-radius: 12px;
		font-size: 16px;
		background: #f8fbff;
	}

	.loginPC .el-input__prefix,
	.loginPC .el-input__suffix {
		display: flex;
		align-items: center;
		height: 100%;
	}

	.loginPC .el-input__prefix {
		left: 12px;
		color: #7a8ca5;
	}

	.loginPC-error-text {
		height: 18px;
		padding-top: 4px;
		font-size: 13px;
		line-height: 18px;
	}

	.loginPC-content-p-btn {
		width: 100%;
		max-width: 480px;
		height: 48px;
		line-height: 48px;
		font-size: 20px;
		font-weight: 700;
		letter-spacing: 6px;
		border-radius: 12px;
		background: linear-gradient(135deg, #178bff 0%, #0f72d8 100%);
		box-shadow: 0 12px 26px rgba(23, 139, 255, 0.26);
	}

	.loginPC-content-p-bottom {
		display: flex;
		align-items: center;
		justify-content: space-between;
		width: 100%;
		max-width: 480px;
		margin-top: 16px;
		font-size: 14px;
		color: #5f6f84;
	}

	.loginPC-content-p-bottom-forget {
		font-size: 14px !important;
		color: #178bff !important;
	}

	.loginPC-content-p-bottom-remember {
		display: inline-flex;
		align-items: center;
		gap: 8px;
	}

	.download {
		max-width: 480px;
		margin: 26px auto 0;
		padding: 14px;
		border: 1px solid #e3edf7;
		border-radius: 16px;
		background: linear-gradient(180deg, #ffffff 0%, #f7fbff 100%);
		box-shadow: 0 10px 22px rgba(18, 52, 77, 0.08);
	}

	.download img {
		width: 82px !important;
		height: 82px !important;
		border-radius: 12px;
	}

	.loginPC-content-Period {
		padding: 48px 54px 42px;
	}

	.loginPC-content-Period-from-check,
	.loginPC-forget-check {
		display: flex;
		gap: 12px;
		margin-bottom: 18px;
	}

	.loginPC-content-Period-from-check-r,
	.loginPC-forget-check>div:last-child {
		padding-left: 0;
	}

	.loginPC-content-Period-from-check-r .el-button,
	.loginPC-forget-check .el-button {
		height: 48px;
		border-radius: 12px;
	}

	.loginPC-forgetdiagl {
		padding-top: 4px;
	}

	.loginPC-forget-bottom {
		display: flex;
		justify-content: flex-end;
		gap: 12px;
		padding: 18px 0 0;
	}

	.loginPC-forget-bottom button {
		width: 94px;
		height: 36px;
		margin-left: 0 !important;
		border-radius: 8px;
	}

	.loginPC-copyright {
		z-index: 2;
		padding-bottom: 14px;
		color: rgba(255, 255, 255, 0.86);
		text-shadow: 0 2px 8px rgba(0, 44, 94, 0.18);
	}

	.text-hover,
	.text-hover:hover {
		color: rgba(255, 255, 255, 0.90);
	}

	@media screen and (max-width: 1440px) {
		.loginPC {
			padding: 48px 64px 52px;
		}

		.loginPC-content {
			min-height: calc(100vh - 100px);
		}

		.loginPC-content-p {
			padding: 44px 46px 40px;
		}
	}

	@media screen and (max-width: 1180px) {
		.loginPC {
			padding: 34px 24px 58px;
			overflow-y: auto;
		}

		.loginPC-content {
			display: flex;
			justify-content: center;
			width: 100%;
			min-height: auto;
			border: none;
			background: transparent;
			box-shadow: none;
			backdrop-filter: none;
		}

		.loginPC-content-img {
			display: none;
		}

		.loginPC-content-p {
			flex: none;
			width: min(520px, 94vw);
			border-radius: 24px;
			box-shadow: 0 24px 58px rgba(10, 42, 83, 0.20);
		}
	}

	@media screen and (max-width: 768px) {
		.loginPC {
			padding: 22px 14px 62px;
		}

		.loginPC-content-p,
		.loginPC-content-Period {
			width: 100%;
			padding: 30px 20px 26px;
			border-radius: 18px;
		}

		.loginPC-content-p-text {
			margin-bottom: 34px;
			font-size: 25px;
		}

		.loginPC-content-Period-from-check,
		.loginPC-forget-check {
			display: block;
		}

		.loginPC-content-Period-from-check-r,
		.loginPC-forget-check>div:last-child {
			margin-top: 10px;
		}

		.loginPC-copyright {
			font-size: 12px;
			line-height: 18px;
			padding: 0 10px 10px;
		}
	}
</style>
<style>
.login-dialog {
	border-radius: var(--fszs-radius-lg);
	box-shadow: var(--fszs-shadow-lg);
	overflow: hidden;
}

.login-dialog .el-dialog__header {
	height: auto;
	line-height: normal;
	padding: 18px 54px 15px 24px;
	vertical-align: middle;
	background: linear-gradient(90deg, rgba(23, 139, 255, 0.10) 0%, rgba(23, 139, 255, 0) 42%), linear-gradient(180deg, #ffffff 0%, #f8fbff 100%);
	border-bottom: 1px solid var(--fszs-border-soft);
	color: var(--fszs-text-strong);
}

.login-dialog .el-dialog__title {
	font-size: 18px;
	font-weight: 700;
	color: #102033 !important;
}

.login-dialog .el-dialog__headerbtn {
	top: 12px;
	right: 16px;
	border-radius: 50%;
}

.login-dialog .el-dialog__headerbtn .el-dialog__close {
	vertical-align: middle;
	font-size: 18px;
	color: #55708b !important;
}
</style>
